import Snackbar from "../PreJoinScreens/MediaErrorSnackbar/Snackbar";
import useRoomState from "hooks/useRoomState";
import React from "react";

export default function ReconnectingNotification() {
  const roomState = useRoomState(null);

  return (
    <Snackbar
      variant="error"
      headline="Connection Lost:"
      message="Reconnecting to room..."
      open={roomState === "reconnecting"}
    />
  );
}
